export default {
  inserted(el, binding) {
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = '0';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.bottom = '0';

    // 允许滚动的白名单区域（类名可自定义）
    const scrollWhitelist = ['scrollable'];

    const preventScroll = (e) => {
      // 如果触发点在允许滚动区域内，不阻止
      let target = e.target;
      while (target && target !== document.body) {
        if (scrollWhitelist.some(cls => target.classList?.contains(cls))) {
          return; // 允许滚动
        }
        target = target.parentNode;
      }

      // 否则阻止默认滚动
      e.preventDefault();
      e.stopPropagation();
    };

    el._preventScroll = preventScroll;
    document.addEventListener('touchmove', preventScroll, { passive: false });
  },

  unbind(el) {
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.bottom = '';

    if (el._preventScroll) {
      document.removeEventListener('touchmove', el._preventScroll);
      delete el._preventScroll;
    }
  }
};
